import { render, staticRenderFns } from "./hydroxid-ionen.vue?vue&type=template&id=154f08f0&"
import script from "./hydroxid-ionen.vue?vue&type=script&lang=js&"
export * from "./hydroxid-ionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports